import React from 'react';

export default function Loading() {
    return (
        <div className='d-flex justify-content-center mb-3'>
            <div className="spinner-border text-success"></div>
        </div>
    );
}
